/**
 * Device API
 * Used for: - Manage Device 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import History from './History';


class HistoryList {
    
    constructor(items, count) { 
        
        HistoryList.initialize(this, items, count);
    }

    
    static initialize(obj, items, count) { 
        obj['items'] = items;
        obj['count'] = count;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new HistoryList();

            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [History]);
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }


}


HistoryList.prototype['items'] = undefined;


HistoryList.prototype['count'] = undefined;






export default HistoryList;

